export default __webpack_public_path__ + "static/media/instructor.e3fcdd1e.jp2";